import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button } from "antd";
import { firestore, storage } from "../../config/firebase";
import { v4 as uuidv4 } from "uuid";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  updateDoc,
  doc,
} from "firebase/firestore";

const StoryModal = ({ isOpen, onClose, selectedUniversity }) => {
  const [form] = Form.useForm();
  const [selectedImage, setSelectedImage] = useState({
    currentImg: "",
    newImg: "",
  });
  const [loading, setLoading] = useState(false);
  const [oldObject, setOldObject] = useState("");
  useEffect(() => {
    form.resetFields();
    let obj = {};
    if (selectedUniversity) {
      form.setFieldsValue({
        title: selectedUniversity.title,
        content: selectedUniversity.content,
      });
      obj.title = selectedUniversity.title;
      obj.content = selectedUniversity.content;
      setOldObject(obj);
      setSelectedImage({
        ...selectedImage,
        currentImg: selectedUniversity.images,
      });
    } else {
    }
  }, [selectedUniversity, form]);

  const handleSave = async () => {
    if (
      !selectedImage.newImg &&
      oldObject.title == form.getFieldValue("title") &&
      oldObject.content == form.getFieldValue("content")
    ) {
      onClose();
      return;
    }
    setLoading(true);
    let remoteUrl;
    if (selectedImage.newImg) {
      const oldImageRef = ref(storage, selectedImage.currentImg);
      await deleteObject(oldImageRef);
      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `success_story/${uniqueFilename}`);
      await uploadBytes(storageRef, selectedImage.newImg);
      remoteUrl = await getDownloadURL(storageRef);
    }
    try {
      const values = await form.validateFields();
      const success_story = {
        title: values.title,
        content: values.content,
      };
      if (remoteUrl) {
        success_story.images = remoteUrl;
      }
      await updateDoc(
        doc(collection(firestore, "success_story"), selectedUniversity.id),
        success_story
      );

      onClose();
      setLoading(false);
      form.resetFields();
      window.location.reload();
    } catch (error) {
      setLoading(false);
      console.error("Error saving post:", error);
    }
  };
  const handleImageChange = async (e) => {
    if (e.target.files.length > 0) {
      setSelectedImage({ ...selectedImage, newImg: e.target.files[0] });
    }
  };

  return (
    <Modal title={"Edit Story"} open={isOpen} onCancel={onClose} footer={null} getContainer={false}>
      <Form form={form} onFinish={handleSave} disabled={loading}>
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Content" name="content" rules={[{ required: true }]}>
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Images">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            disabled={loading}
          />
        </Form.Item>
        <div style={{ marginTop: "16px" }}>
          <img
            src={selectedImage.currentImg}
            style={{ width: "100px", height: "100px", marginRight: "8px" }}
          />
        </div>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StoryModal;
